import React from 'react';
import { Link } from 'react-router-dom';

import GameOfLifeCanvas from './gameOfLife/GameOfLifeCanvas.js';
import ECGSketch from './monitors/ECGSketch.js';
import MAPSketch from './monitors/MAPSketch.js';
import MonitorClock from './monitors/MonitorClock.js';
import PlethSketch from './monitors/PlethSketch.js';
import RespSketch from './monitors/RespSketch.js';
import TemperatureReadout from './monitors/TemperatureReadout.js';

import './style/Home.scss';

const Intro = () => (
  <div className="monitor-header">
    <Link to="/about" className="rounded header-link">
      <div className="flex col" style={{ flex: 1 }}>
        <div>Anthony Bosshardt, MD</div>
        <div>Physician • Software Engineer</div>
      </div>
    </Link>
    <div className="date text-right">
      <MonitorClock />
    </div>
  </div>
);

const Home = () => (
  <div className="home-monitor">
    <GameOfLifeCanvas />
    <div className="flex col vital-signs-container">
      <Intro />
      <ECGSketch />
      <MAPSketch />
      <PlethSketch />
      <RespSketch />
      <div className="monitor-footer">
        <TemperatureReadout />
      </div>
    </div>
  </div>
);

export default Home;
